import React from 'react'
import { Empty, EmptyDetail } from 'prospect-path-components';
import { Button } from 'prospect-path-base';
import {connect } from 'react-redux';

class BlankCampaignsPage extends React.Component
{
  render() {
    const params = new URLSearchParams({
      name: this.props.user.first_name ? this.props.user.first_name : '',
      email: this.props.user.email ? this.props.user.email : '',
      phone: this.props.user.phone_number ? this.props.user.phone_number : '',
      company: this.props.user.vendor_name ? this.props.user.vendor_name : '',
    });

    return (
      <Empty
        style={{ marginBottom: '2.5rem' }}
        footerImage={(
          <svg width="100%" height="120" viewBox="0 0 550 144" fill="none" xmlns="http://www.w3.org/2000/svg">
            <defs />
            <rect y="14" width="56" height="20" rx="10" fill="#EAEAEA" />
            <rect x="80" y="14" width="336" height="20" rx="10" fill="#BBB" />
            <rect x="507" y="14" width="43" height="20" rx="10" fill="#EAEAEA" />
            <g opacity=".5">
              <rect y="62" width="56" height="20" rx="10" fill="#EAEAEA" />
              <rect x="80" y="62" width="336" height="20" rx="10" fill="#BBB" />
              <rect x="507" y="62" width="43" height="20" rx="10" fill="#EAEAEA" />
            </g>
            <g opacity=".2">
              <rect y="110" width="56" height="20" rx="10" fill="#EAEAEA" />
              <rect x="80" y="110" width="336" height="20" rx="10" fill="#BBB" />
              <rect x="507" y="110" width="43" height="20" rx="10" fill="#EAEAEA" />
            </g>
          </svg>
        )}
      >
        <EmptyDetail
          title="Start your first campaign"
          subtitle="Start a campaign to begin reaching best-fit software buyers"
          action={(
            <div style={{
              display: 'flex',
              justifyContent: 'center'
            }}>
              <Button
                size="small"
                color="primary"
                onClick={() => window.open(`https://info.prospectpath.com/create-campaign/?${params.toString()}`, '_blank')}
              >
                Start a campaign
              </Button>
            </div>
          )}
        />
      </Empty>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
});

export default connect(mapStateToProps)(BlankCampaignsPage);
